import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSegment } from '@angular/router';
import { AffiliationPageComponent } from './affiliation-page.component';

export function affiliationMatcher(url: UrlSegment[]) {
  const affiliationPath = [
    'affiliation.shtml',
    'affiliate-program.shtml',
    'affiliate-programm.shtml',
    'programa-de-afiliacion.shtml',
    'programma-di-affiliazione.shtml'
  ];
  return url.length > 0 && affiliationPath.includes(url[0].path) ? { consumed: url } : null;
}

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: AffiliationPageComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AffiliationPageRoutingModule {}
